import baseApi from './base';
import myElearningsApi from './myElearnings';
import resourcesApi from './resources';
import reviewersApi from './reviewers';
import helperApi from './helper';
import templatesApi from './templates';
import framesApi from '@/modules/services/frames';
import quizzesApi from '@/modules/services/quizzes';
import questionsApi from '@/modules/services/questions';
import authApi from '@/modules/services/auth';
import themesApi from '@/modules/services/themes';
import elementsApi from '@/modules/services/elements';
import choiceApi from './choices';
import commentApi from './comments';
import manifestApi from '@/modules/services/manifest';
import publishedEntityApi from '@/modules/services/publishedEntities';
import courseLibraryApi from '@/modules/services/courseLibrary';
import navigationApi from '@/modules/services/navigation';
import elearningCategoriesApi from '@/modules/services/elearningCategories';
import tenantsApi from '@/modules/services/tenants';
import videoLibraryApi from '@/modules/services/videoLibrary';
import scormApi from '@/modules/services/scorm';
import breatheApi from '@/modules/services/breathe';

export const {
  useGetLibraryElearningsQuery,
  useGetLibraryElearningV2Query,
  useDownloadLibraryV2Mutation,
  useGetDownloadCourseResultQuery,
  useStartDownloadCourseMutation,
} = courseLibraryApi;
export const {
  useGetVideoLibraryElearningsQuery,
  useGetVideoLibraryElearningV2Query,
  useGetVocamRegionsQuery,
  useGetVocamChannelsQuery,
  useGetVocamModulesQuery,
  useGetVocamChaptersQuery,
  useGetVideoPreviewLinkQuery,
  useGetVideoLinkQuery,
} = videoLibraryApi;
export const {
  useGetMyLibraryQuery,
  useGetElearningQuery,
  usePublishElearningMutation,
  useGetPublishResultQuery,
  useDeleteElearningMutation,
  useUpdateElearningMutation,
  useGetElearningDetailsQuery,
} = myElearningsApi;
export const { useGetResourcesQuery, usePostResourceMutation } = resourcesApi;
export const { useGetHelperContentQuery, useGetHelperFaqQuery } = helperApi;
export const {
  useGetTemplatesQuery,
  useGetFavouriteTemplatesQuery,
  useGetTemplateQuery,
  useUpdateTemplateMutation,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
} = templatesApi;
export const {
  useGetThemesQuery,
  useGetThemeQuery,
  useGetDefaultThemeQuery,
  useCreateThemeMutation,
  useDeleteThemeMutation,
  useUpdateThemeMutation,
} = themesApi;
export const {
  useGetFramesQuery,
  useLazyGetFramesQuery,
  useAddFrameMutation,
  useUpdateFrameMutation,
  useRepositionFrameMutation,
  useDeleteFrameMutation,
  useDuplicateFrameMutation,
} = framesApi;
export const {
  useGetChoicesQuery,
  useCreateChoiceMutation,
  useUpdateChoiceMutation,
  useDeleteChoiceMutation,
} = choiceApi;
export const {
  useGetQuizzesQuery,
  useGetQuizQuery,
  useUpdateQuizMutation,
  useCreateQuizMutation,
  usePostQuizQuestionsMutation,
  useGetFirstRandomQuestionMutation,
  useSubmitQuizResultMutation,
  useSubmitQuizResultLiveMutation,
  useGetLiveQuizAttemptQuery,
  useStartLiveQuizAttemptMutation,
  useEvaluateLiveQuizAttemptMutation,
} = quizzesApi;
export const {
  useGetQuestionQuery,
  useGetQuestionsQuery,
  useCreateQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useSubmitAnswerMutation,
  useRepositionQuestionMutation,
} = questionsApi;
export const {
  useGetTokenQuery,
  useGetUserInfoQuery,
  useGetSignedCookiesQuery,
  useGetTenantsQuery,
  useGetTenantQuery,
  useGetCurrentTenantProfileQuery,
  useUpdateTenantProfileMutation,
  useGetCapabilitiesQuery,
  useGetSignedCookiesAdminQuery,
  useLazyGetSignedCookiesAdminQuery,
} = authApi;
export const { useGetManifestQuery, useLazyGetManifestQuery } = manifestApi;
export const {
  useGetElearningJsonQuery,
  useLazyGetElearningJsonQuery,
  useGetQuizJsonQuery,
  useGetHelpJsonQuery,
} = publishedEntityApi;
export const {
  useCreateElementMutation,
  useDeleteElementMutation,
  useRepositionElementMutation,
} = elementsApi;
export const {
  useGetReviewersQuery,
  useCreateReviewerMutation,
  useGetTmsReviewersQuery,
  useGetCurrentTmsReviewerQuery,
  useFinaliseReviewerMutation,
  useStartReviewMutation,
} = reviewersApi;
export const {
  useGetFrameCommentsQuery,
  useGetReviewerCommentsQuery,
  useCreateCommentMutation,
  useDeleteCommentMutation,
  useUpdateCommentMutation,
  useUpdateCommentStatusMutation,
  useGetReviewerElearningCommentsQuery,
} = commentApi;
export const { useGetNavigationsQuery } = navigationApi;
export const {
  useGetElearningCategoriesQuery,
  useGetElearningCategoriesV2Query,
  useGetElearningCategoryQuery,
  useGetElearningAllowedCategoriesQuery,
  useUpdateCategoryAccessMutation,
  useGetElearningCategoriesPerTenantQuery,
  useCreateElearningCategoriesMutation,
  useUpdateElearningCategoriesMutation,
} = elearningCategoriesApi;

export const {
  useGetElearningBehaviourSettingsQuery,
  useGetTenantCategoryListQuery,
  useUpdateTenantCategoryAccessMutation,
} = tenantsApi;

export const {
  useGetScormSignedCookiesQuery,
  useDownloadScormPackageMutation,
  useGetScormVocamVideoLinkQuery,
} = scormApi;

export const {
  useGetBreatheLaunchQuery,
  useSubmitBreatheCompletionMutation,
  useGetBreatheVocamVideoLinkQuery,
} = breatheApi;

export {
  useSubmitAiCreateMutation,
  useRetryAiGenerationMutation,
  useGetAiGenerationStatusQuery,
} from './aiCreate';

export {
  useImportPptMutation,
  useGetImportStatusQuery,
  useTweakSlideMutation,
  useRegeneratePptxSlideMutation,
} from './pptImport';

export default baseApi;
